import { createSelector, createStructuredSelector } from "reselect"
import { List } from "immutable"

export const selectFormattedIssues = createSelector(
    (state, props) => props.issues || List(),
    (issues) =>
        issues.map((immutableIssue) => {
            if (!immutableIssue.has("displayText")) {
                // issues from issues props have parent name stored in parent__name
                // while issues added from the select component have issues stored in `_extra.parent_name`
                const parentName = immutableIssue.get("parent__name") || immutableIssue.getIn(["_extra", "parent_name"])
                return parentName
                    ? immutableIssue.set("displayText", `${immutableIssue.get("name")} (${parentName})`)
                    : immutableIssue.set("displayText", immutableIssue.get("name"))
            }
            return immutableIssue
        })
)

export const selectButtonText = createSelector(selectFormattedIssues, (formattedIssues) => {
    if (formattedIssues.size) {
        return formattedIssues.map((issue) => issue.get("displayText")).join(", ")
    }
    return "Issue Not Selected"
})

export const selectQuorumDataTypeEnum = createSelector(
    (state, props) => props.quorumDataType,
    (quorumDataType) => quorumDataType && DjangIO.app.models.QuorumDataType.by_value(quorumDataType)
)

const resourceTableIssueAdderConnection = createStructuredSelector({
    buttonText: selectButtonText,
    formattedIssues: selectFormattedIssues,
    quorumDataTypeEnum: selectQuorumDataTypeEnum,
})

export default resourceTableIssueAdderConnection
